import AjaxRequest from './AjaxRequest';

export default class Content
{
    getSeniorImages() {
        return new AjaxRequest().get('content/seniors', null);
    }

    getBanner() {
        return new AjaxRequest().get('content/banner', null);
    }

    saveBanner(data) {
        return new AjaxRequest().patch('content/banner', data);
    }
}
